// extracted by mini-css-extract-plugin
export default {"toggleEntry":"_2kR_IwnR1Wkotzaxn4e"};